import { Outlet } from 'react-router-dom';
import Header from '../components/layouts/Header';
import Sidebar from '../components/layouts/Sidebar';
import { HeaderProvider } from '@/context/HeaderTitleContext';

const RootPage = () => {

    return (
        <HeaderProvider>
            <div className="w-full bg-gray-100">
                <div className="flex">
                    <Sidebar />
                    <div className="w-[83%] h-[max-content] p-8">
                        <Header />
                        <div className="mt-8 rounded-2xl">
                            <Outlet />
                        </div>
                    </div>
                </div>
            </div>
        </HeaderProvider>
    );
};

export default RootPage;
